import type { RouteLocationNormalized } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import { useUserStore } from '@/stores/user';

export const changeEmail = async (to: RouteLocationNormalized) => {
  const authStore = useAuthStore();
  const userStore = useUserStore();
  const verificationId = to.query['verification-request-id'] as string;

  if (authStore.isAuthorized.value) {
    try {
      await userStore.changeEmailVerify(verificationId);
      return { name: 'security', query: { emailChanged: true } };
    } catch {}
  } else {
    return { name: 'root' };
  }
};
